import { render, staticRenderFns } from "./holiday_menu.vue?vue&type=template&id=4fe391f2&scoped=true"
import script from "./holiday_menu.vue?vue&type=script&lang=js"
export * from "./holiday_menu.vue?vue&type=script&lang=js"
import style0 from "./holiday_menu.vue?vue&type=style&index=0&id=4fe391f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe391f2",
  null
  
)

export default component.exports